module.exports = __webpack_public_path__ + "img/team-9.0527b39.webp";